import { Table, Dropdown,Pagination,Form } from 'react-bootstrap'; // Import Dropdown from react-bootstrap
import { FiMoreVertical } from 'react-icons/fi'; // Import the vertical dots icon
import './ActionMenu.style.scss';

import React, { useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Spinner } from "react-bootstrap";
import './Table.style.scss';
import SearchInput from "../../Atoms/SearchInput/SearchInput";
import {postMethod} from "../../../Helpers/services"
import TableSkeleton from "../Table/TableSkeleton"
import NoListData from "./NoListData";
import _ from "lodash";
import { PrimaryButton } from "../../Atoms/Button/Button";
import {resend_activation_link,cutomer_resend_activation_link} from "../../../Enums/api_constunts"
import { showToast } from "../../Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UpdateStatus from "../../../Pages/UpdateStatus"
import moment from 'moment';

const DataTable = ({reloadList, columnDefs, apiUrl,filterData={},setFilterData,setOpenForm,editRow, showCreateBtn,loaded_from }) => {
  const navigateTo = useNavigate()
  const [modelOpen,SetModelOpen ] = useState(0)
  const [selectedItem, setSelectedItem] = useState(null)
  const [isSpinner, setIsSpinner] = useState(false);
  const userData = useSelector((state) => state.auth.user);
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [per_page, setperPage] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  
  const fetchData = async (search_string='') => {
    setLoading(true);
      let postData = {page:currentPage,per_page:per_page}
      if(_.get(Object.keys(filterData),"length")>0){
        
        Object.keys(filterData).forEach((key)=>{
          postData[key] = filterData[key]
        })
      }
      postData["page"] = currentPage
      postData["per_page"] = per_page
      postData["search_string"] = search_string
      setFilterData(postData)
      
      postMethod(apiUrl,postData).then((res)=>{
        let list =[]
        let total_count =0
        
        if(_.has(res,"total_count") && _.get(res,"total_count") >0 ){
          total_count = res["total_count"]
        }else if(_.has(res,"result.total_count") && _.get(res,"result.total_count") >0 ){
          total_count = res["result"]["total_count"]
        }

        if(_.has(res,"list") && _.get(res,"list.length") >0 ){
          list = res["list"]
        }else if(_.has(res,"result.list") && _.get(res,"result.list.length") >0 ){
          list = res["result"]["list"]
        }
        if(total_count>0){
          let pages = total_count/per_page
          setTotalPages(Math.round(pages))
        }
       
        //setTotalPages((res["total_count"])/per_page)
        list = list.map((item,index)=>{
          
          item["index"] = ((currentPage-1)*per_page)+(index+1)
          item["show_menu"] =false
          if( 
            (["SUPPORT_TICKETS_LIST"].indexOf(loaded_from ) >-1 )||

            ( ["LEADS_LIST"].indexOf(loaded_from)>-1 && _.get(userData,"role_id") )
            || (["CUSTOMERS_LIST","SUBSCTIBERS_LIST"].indexOf(loaded_from)>-1)
            ||(loaded_from=="SERVICE_CONFIGURATION_LIST")
            || (loaded_from=="AGENT_LIST") 
            || (loaded_from=="USERS_LIST")
            //|| (loaded_from =="CUSTOMERS_LIST" && _.get(item,"loan_applications_list.length")>0 && _.get(item,"loan_applications_list[0].status_id")==1)
            || (loaded_from =="ENQUIRY_LIST" && _.get(item,"status_id")!=2)
          ){
            item["show_menu"] = true
          }

          return item

        })
        setRowData(list); 
        setLoading(false);
      }).catch (()=>{
        setLoading(false);
        setRowData([])
        setTotalPages(0)
      })
  };

  const handlePerPageChange = (e)=>{
    setperPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to page 1 when perPage is changed
  }
  // Fetch data when page changes
  useEffect(() => {
    fetchData()
  }, [currentPage,per_page,reloadList]);

  const handlePageChange = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
    }
  };
  const [showMenu, setShowMenu] = useState(null);

  const toggleMenu = (id) => {
    
    setShowMenu(id);
  };
  const handleMenu = (row,type='')=>{
   
    
    if((loaded_from=="USERS_LIST" || loaded_from=="AGENT_LIST" )){

      if(type=="RESEND_ACTIVATION_LINK"){
        resendActivationLink({"email":row["email"]})
      }
    else if( type== "UPDATE_STATUS" ){
      SetModelOpen(1)
      setSelectedItem(row)
    }else if(type== "DETAILS"){
      editRow(row, type)
    }
  }
   
    else if( ["LEADS_LIST"].indexOf(loaded_from)>-1){
      editRow(row, type)
    }else if(["SUBSCTIBERS_LIST","CUSTOMERS_LIST"].indexOf(loaded_from)>-1){
      if(type=="RESEND_ACTIVATION_LINK"){
        resendActivationLink({"email":row["email"]})
      }else{
        editRow(row, type)
      }
    }else if(type=="RESEND_ACTIVATION_LINK")
      resendActivationLink({"email":row["email"]})
    
    else if (type=="EDIT")
      editRow(row)
    if(loaded_from=="ENQUIRY_LIST"){
        
        editRow(row, type)
      

    }else if(type=="SHOW_DETAILS" && loaded_from=="SUPPORT_TICKETS_LIST"){
      
      editRow(row, type)
    }
    
  }

  const resendActivationLink = (values)=>{
    //setIsSpinner(true);
    let url = resend_activation_link
    if(["SUBSCTIBERS_LIST","CUSTOMERS_LIST"].indexOf(loaded_from)>-1){
      url = cutomer_resend_activation_link;
    }
    postMethod(url,values).then((result)=>{
     
      //setIsSpinner(false);
      setShowMenu(null)
      showToast("success",_.get(result, "message","Something went wrong!"))
      
    }).catch((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      
      
    })
  }
  useEffect(()=>{
    if(modelOpen==0){
      setSelectedItem(null)
    }
    
  },[modelOpen]);


  return (
    <div  className="table-card" onClick={()=>{
      if(showMenu>0){
        setShowMenu(null)
      }
    }}>
      
      
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <SearchInput oNdebouncedSearch={(v)=>fetchData(v)} />
        {showCreateBtn&&<div onClick={()=>{ setOpenForm(1)}}>
        <PrimaryButton type="button" label="Create"/>
          </div>}
      </div>
      <div className="ag-theme-alpine" style={{ minHeight: '500px', width: "100%", paddingTop: "20px"}} >
      {loading &&  <TableSkeleton rows={10} columns={12} columnDefs={columnDefs}  />}
      { !loading && rowData.length<=0 &&  <NoListData/>  }
      { !loading && rowData.length >0 && (
        <div className="table-responsive-wrapper">
          <Table hover className="custom-table">
            <thead>
              <tr>
                {columnDefs.map((item, index) => (
                  <th key={index}>{item.headerName}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rowData.map((row) => (
                <tr key={row.id}>
                  {columnDefs.map((column, colIndex) => (
                    <td key={colIndex}>
                      {column.field === "actions" ? (
                        <td className="action-cell">
                          <Dropdown 
                            align="end" 
                            show={showMenu === row.id}
                            onToggle={(isOpen) => {
                              if (!isOpen) {
                                setShowMenu(null);
                              }
                            }}
                          >
                            <Dropdown.Toggle 
                              as="div" 
                              className="action-toggle-button"
                              id={`dropdown-${row.id}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowMenu(showMenu === row.id ? null : row.id);
                              }}
                            >
                              <button className="action-menu-btn">View</button>
                            </Dropdown.Toggle>

                            <Dropdown.Menu 
                              className="action-dropdown-menu"
                              popperConfig={{
                                strategy: 'absolute',
                                modifiers: [
                                  {
                                    name: 'offset',
                                    options: {
                                      offset: [0, 4],
                                    },
                                  },
                                ],
                              }}
                            >
                              {
                                ["SUPPORT_TICKETS_LIST"].indexOf(loaded_from )>-1 && <li  onClick={()=>handleMenu(row,"SHOW_DETAILS")} >Details</li>
                              }
                              
                              { 
                              ["CUSTOMERS_LIST","SUBSCTIBERS_LIST"].indexOf(loaded_from)>-1 &&
                              <>
                              {row["status_id"] ==2 && <><li onClick={()=>handleMenu(row,"RESEND_ACTIVATION_LINK")}>Resend Activation Link </li></>}
                              <li onClick={()=>handleMenu(row,"APPLY_LOAN")}>Apply Loan </li> 
                              <li   onClick={()=>handleMenu(row,"FILL_DATA")} >Fill Data</li>
                              <li   onClick={()=>handleMenu(row,"SHOW_DETAILS")} >Details</li>
                              </>

                              }
                              {
                                ["LEADS_LIST"].indexOf(loaded_from)>-1&& <>
                                { _.get(userData,"role_id") !=5  && <li   onClick={()=>handleMenu(row,"FILL_DATA")} >Fill Data</li>}
                                <li   onClick={()=>handleMenu(row,"SHOW_DETAILS")} >Details</li>
                                </>
                              }
                              { loaded_from =="SERVICE_CONFIGURATION_LIST" && <li   onClick={()=>handleMenu(row,"EDIT")} >Edit</li>}
                                { (loaded_from=="USERS_LIST" || loaded_from=="AGENT_LIST" )&& <>

                                  <li onClick={()=>handleMenu(row,"DETAILS")}>Details</li>
                                  {row["status_id"] ==2 && [1,2,3,4].indexOf(userData?.role_id)>-1  && <><li onClick={()=>handleMenu(row,"RESEND_ACTIVATION_LINK")}>Resend Activation Link </li></>}
                                  {row["status_id"] ==3 && [1,2].indexOf(userData?.role_id)>-1  && <><li onClick={()=>handleMenu(row,"UPDATE_STATUS")}>Inactive </li></>}
                                  {row["status_id"] >3 && [1,2].indexOf(userData?.role_id)>-1  && <><li onClick={()=>handleMenu(row,"UPDATE_STATUS")}>Activate </li></>}
                                </>
                                }
                                { 
                                loaded_from =="CUSTOMERS_LIST" && false && _.get(row,"loan_applications_list.length")>0 && _.get(row,"loan_applications_list[0].status_id")==1&&<li   onClick={()=>navigateTo(`/loan-application-form?loanApplicationId=${_.get(row,'loan_applications_list[0].id')}`)} >Fill Loan Form Data</li>
                                }
                                
                                { loaded_from =="ENQUIRY_LIST" && _.get(row,"status_id")!=2 && <li   onClick={()=>handleMenu(row,"UPDATE_ENQUIRY")} >Update Status</li>}
                                
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      ) : (
                        <div className="table-cell">
                          {["start_date", "end_date", "followupdate", "created_on", "updated_on"].includes(column.field) ? (
                            <span className="date-cell">
                              {_.get(row, `${column.field}`) && 
                                moment.utc(_.get(row, `${column.field}`)).local().format("DD-MMM-YYYY")}
                            </span>
                          ) : (
                            _.get(row, `${column.field}`)
                          )}
                        </div>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

       {/* Pagination Controls */}
       <div style={{"paddingLeft" : "10px" }} className="d-flex justify-content-between align-items-center mt-3 ">
        {/* Per Page Dropdown */}
        <div className="per-page-dropdown">
          <span>Per page:</span>
          <Form.Control as="select" value={per_page} onChange={handlePerPageChange} style={{ width: '120px', display: 'inline-block' }}>
          
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
          </Form.Control>
        </div>

        {/* Pagination Controls */
        totalPages >0 && <Pagination className="ml-auto">
          <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
          {[...Array(totalPages)].map((_, index) => (
            <Pagination.Item key={index} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        </Pagination>
        }
      </div>

    </div>

    {modelOpen==1 && _.has(selectedItem,"id") && <>
      
      <UpdateStatus fetchData={()=>{fetchData()}} selectedItem={selectedItem} openUpdatePassword={modelOpen}  SetOpenUpdatePassword={()=>SetModelOpen(0)}/>
      </>
      }
    </div>
  );
};

export default DataTable;
